<template>
  <div id="order">
    <!--工具条-->
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item>
        <el-input
          id="maininput"
          placeholder="输入查询的单号"
          prefix-icon="el-icon-search"
          v-model="key.id"
          @keyup.enter.native="doSelect"
          @submit.native.prevent
        ></el-input>
      </el-form-item>
      <el-form-item v-if="roles.indexOf('4')>-1">
        <el-checkbox v-model="key.superSearch" style="margin-left: 20px">高级筛选</el-checkbox>
      </el-form-item>
      <el-form-item v-if="roles.indexOf('4')>-1">
        <el-button type="primary" v-on:click="doSelect">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="showAddNew" v-if="roles.indexOf('1')>-1">下单</el-button>
      </el-form-item>
    </el-form>
    <!-- 高级搜索 -->
    <el-row
      v-if="key.superSearch"
      style="width: 100%; margin-bottom:20px; background-color: #eee; border-radius: 8px;"
    >
      <el-form :inline="true" style="margin: 20px 10px 0px 20px" :gutter="20">
        <el-form-item label="下单日期">
          <el-date-picker
            style="width:280px"
            v-model="key.searchTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="客户" style="margin-left:30px" v-if="roles.indexOf('1')>-1">
          <el-select
            v-model="key.customer"
            clearable
            filterable
            placeholder="请选择客户"
            style="width: 150px"
            @focus="getCustomers"
          >
            <el-option
              v-for="item in customers"
              :key="item.toString()"
              :label="item.toString()"
              :value="item.toString()"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态" style="margin-left:30px">
          <el-select v-model="key.orderStatus" clearable style="width:140px">
            <el-option label="新订单" value="0"></el-option>
            <el-option label="刀模选择" value="1"></el-option>
            <el-option label="选取领用材料" value="2"></el-option>
            <el-option label="余量称重" value="3"></el-option>
            <el-option label="完成" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="key.isCloseOrder" style="margin-left: 20px">完成的订单</el-checkbox>
        </el-form-item>
      </el-form>
    </el-row>

    <!--工具条-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:left;"
    ></el-pagination>

    <!-- 列表 -->
    <el-table
      :data="pageInfos"
      border
      style="width: 100%"
      :height="tableHeight"
      v-loading="listLoading"
      lazy
    >
      <el-table-column label="订单编号" width="100px" fixed>
        <template slot-scope="scope">
          <el-button type="text" @click="doSelectItem(scope.row.id,'select')">{{scope.row.id}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="customer" label="客户" width="150px" v-if="roles.indexOf('1')>-1"></el-table-column>
      <el-table-column
        prop="labelInfo"
        label="标签"
        width="155px"
      ></el-table-column>
      <el-table-column prop="material" label="材料" width="180px"></el-table-column>
      <el-table-column label="打印" width="60px" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" type="text">
            <!-- <el-button @click="test">测试</el-button> -->
            <a href="javascript:void(0)" @click="doSelectItem(scope.row.id,'print')">打印</a>
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="180px"
        v-if="roles.indexOf('1')>-1"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column label="订单操作" width="130px" v-if="roles.indexOf('1')>-1">
        <template slot-scope="scope">
          <el-button
            size="small"
            v-if="roles.indexOf('1')>-1"
            type="text"
            @click="showCopy(scope.row.id)"
          >复制</el-button>
          <el-button
            v-if="scope.row.status==0&&roles.indexOf('3')>-1"
            size="small"
            type="text"
            @click="showEdit(scope.row.id)"
          >修改</el-button>
          <el-button
            v-if="scope.row.status==0&&roles.indexOf('2')>-1"
            size="small"
            type="text"
            @click="doDelete(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>
      <el-table-column label="附件" width="110px">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.haveAttachment==true"
            size="small"
            type="text"
            @click="doShowUpload(scope.row.id)"
          >查看</el-button>
          <el-button
            v-if="scope.row.status==0&&scope.row.haveAttachment==true&&roles.indexOf('2')>-1"
            size="small"
            type="text"
            @click="deUpload(scope.row.id)"
          >删附件</el-button>
          <el-button
            v-if="scope.row.status==0&&scope.row.haveAttachment==false&&roles.indexOf('1')>-1"
            size="small"
            type="text"
            @click="doUpload(scope.row.id)"
          >传附件</el-button>
          <span v-if="scope.row.status!=0&&scope.row.haveAttachment==false">无</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="430px">
        <template slot-scope="scope">
          <el-steps :active="scope.row.status" finish-status="success">
            <el-step title="新订单"></el-step>
            <el-step title="刀模选取"></el-step>
            <el-step title="材料选取"></el-step>
            <el-step title="余量称重"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="下单日期" width="100px"></el-table-column>
      <el-table-column prop="deliveryTime" label="交货日期" width="100px"></el-table-column>
      <el-table-column prop="planTime" label="计划日期" width="100px"></el-table-column>
      <el-table-column prop="createUser" label="下单人" width="80px"></el-table-column>
      <el-table-column prop="salesman" label="业务员" width="80px"></el-table-column>
    </el-table>

    <!-- 订单弹窗界面-->
    <el-dialog
      :title="dialogFrom.title+'  '+(dialogFrom.suggestDate!=''?'建议: '+dialogFrom.suggestDate+' 交货':'')"
      :visible.sync="dialogFrom.visible"
      :close-on-click-modal="false"
      width="1300px"
      top="10px"
      :show-close="false"
    >
      <OrderInfo :order="order" :disabled="dialogFrom.disabled" :label="label"></OrderInfo>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetInfo(false)">取消</el-button>
        <el-button
          type="primary"
          @click="doConfirm"
          :loading="dialogFrom.confirmLoading"
          v-if="dialogFrom.haveConfirm"
        >提交</el-button>
      </div>
    </el-dialog>

    <!-- 上传弹窗界面-->
    <el-dialog
      :title="uploadFrom.title"
      :visible.sync="uploadFrom.visible"
      :close-on-click-modal="false"
      :show-close="false"
      width="300px"
    >
      <el-row v-if="uploadFrom.crud=='c'">
        <el-upload
          ref="upload"
          action="/api/production/upload"
          :data="uploadFrom"
          :limit="2"
          :auto-upload="false"
          :on-exceed="handleExceed"
          accept="image/*, .rar, .zip"
          :on-success="uploadSuccess"
        >
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <div slot="tip" class="el-upload__tip">一张图片 + 一个压缩文件</div>
        </el-upload>
      </el-row>
      <el-row v-else>
        <Attachment :attachmentInfo="uploadFrom.files" :orderId="uploadFrom.title"></Attachment>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadFrom.visible=false">取消</el-button>
        <el-button v-if="uploadFrom.crud=='c'" type="primary" @click="submitUpload">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template> 

<script>
import OrderInfo from "@/components/production/OrderInfo";
import Attachment from "@/components/production/Attachment";
import { Order, Label } from "@/models/production";

export default {
  components: {
    OrderInfo,
    Attachment
  },
  data: function() {
    return {
      tableHeight: window.innerHeight - 275,

      //订单弹窗信息
      dialogFrom: {},

      //文件弹窗信息
      uploadFrom: {},

      //查询加载界面
      listLoading: false,

      //查询数据关键字
      key: {
        superSearch: false,
        id: "",
        searchTime: "",
        orderStatus: "",
        customer: "",
        isCloseOrder: false
      },

      //终端发出
      postApi: {},

      //终端接收
      message: {
        result: {
          infos: []
        }
      },

      //分页显示信息
      page: 1,
      total: 0,
      pageSize: 10,
      pageInfos: [],
      pageSizes: [10, 20, 30, 40, 10000],

      //订单信息
      order: {},

      //标签信息
      label: {},

      customers: []
    };
  },
  created: async function() {
    this.resetInfo(true);
  },
  methods: {
    //初始化弹窗 终端发出 订单 和 标签信息
    resetInfo: function(refresh) {
      this.dialogFrom = {
        visible: false,
        title: "",
        crud: "",
        disabled: false,
        haveConfirm: false,
        confirmLoading: false,
        isCopy: "",
        suggestDate: ""
      };
      this.postApi = {
        crud: "",
        info: {}
      };
      this.uploadFrom = {
        visible: false,
        title: "",
        ordreId: "",
        crud: "",
        files: {
          pic: "",
          zip: ""
        }
      };
      this.order = new Order();
      this.label = new Label();
      if (refresh) {
        this.doSelect();
      }
    },
    //新增
    showAddNew: function() {
      this.dialogFrom = {
        visible: true,
        title: "新订单",
        crud: "c",
        disabled: false,
        haveConfirm: true,
        confirmLoading: false,
        isCopy: "",
        suggestDate: ""
      };
    },
    //复制订单
    showCopy: async function(orderId) {
      this.postApi.crud = "ri";
      this.postApi.info = {
        key: orderId
      };
      this.message = await this.$doPost("/api/production/order", this.postApi);
      if (this.message.msgCode == 0) {
        var res = this.message.result.infos;
        this.order = res.order;
        this.order.id = orderId.substring(0, 5);
        this.order.deliveryTime = "";
        this.order.createTime = "";
        this.label = res.label;
        this.dialogFrom = {
          visible: true,
          title: "复制单据: " + orderId,
          crud: "c",
          disabled: false,
          haveConfirm: true,
          confirmLoading: false,
          isCopy: orderId,
          suggestDate: ""
        };
      } else {
        this.$message.error(this.message.msg);
      }
    },
    //编辑
    showEdit: async function(orderId) {
      this.postApi.crud = "ri";
      this.postApi.info = {
        key: orderId
      };
      this.message = await this.$doPost("/api/production/order", this.postApi);
      if (this.message.msgCode == 0) {
        var res = this.message.result.infos;
        this.order = res.order;
        // this.order.id = orderId.substring(0, 5);
        this.label = res.label;
        this.dialogFrom = {
          visible: true,
          title: "修改单据: " + orderId,
          crud: "u",
          disabled: false,
          haveConfirm: true,
          confirmLoading: false,
          suggestDate: ""
        };
      } else {
        this.$message.error(this.message.msg);
      }
    },
    //查看单条信息
    doSelectItem: async function(orderId, doWhat) {
      if (doWhat == "print") {
        // console.log(orderId)
        location.href = "WebPrinter://" + orderId + ",order";
      } else if (doWhat == "select") {
        this.postApi.crud = "ri";
        this.postApi.info = {
          key: orderId
        };
        this.message = await this.$doPost(
          "/api/production/order",
          this.postApi
        );
        if (this.message.msgCode == 0) {
          var res = this.message.result.infos;
          this.order = res.order;
          this.label = res.label;
          if (this.roles.indexOf("1") == -1) {
            this.label.customer = "*";
          }
          this.dialogFrom = {
            visible: true,
            title: "单据号: " + orderId,
            crud: "c",
            disabled: true,
            haveConfirm: false,
            confirmLoading: false,
            suggestDate: ""
          };
        } else {
          this.$message.error(this.message.msg);
        }
      }
    },
    //弹窗信息上传
    doConfirm: async function(e) {
      var error = "";
      var now = new Date();
      if (this.order.deliveryTime == "" || this.order.deliveryTime == null) {
        error += "/请选择交货日期 ";
      } else {
        var date = new Date(this.order.deliveryTime.replace(/-/g, "/"));
        if (now.getTime() > date.getTime()) {
          error += "/交货日期不能小于今天 ";
        }
      }

      if (this.order.salesman == "") {
        error += "/请选择业务人员 ";
      }

      if (this.label.material == "") {
        error += "/请选择标签材料 ";
      }
      if (this.label.lbWidth == 0 || this.label.lbLength == 0) {
        error += "/标签长宽不能为0 ";
      }
      if (this.label.customer == "") {
        error += "/请选择客户 ";
      }
      if (error != "") {
        this.$message.error({
          message: error
        });
      }
      if (error == "") {
        this.$confirm("确认提交吗？", "提示", {})
          .then(async () => {
            this.postApi.crud = this.dialogFrom.crud;
            this.order.id = this.order.type == "C" ? "M" : "Y";
            this.postApi.info = {
              order: this.order,
              label: this.label,
              key: this.postApi.info.key,
              isCopy: this.dialogFrom.isCopy
            };
            this.dialogFrom.confirmLoading = true;
            let res = await this.$doPost("/api/production/order", this.postApi);
            this.dialogFrom.confirmLoading = false;
            if (res.msgCode === 0) {
              if (this.dialogFrom.crud == "c" && this.dialogFrom.isCopy == "") {
                this.$confirm("是否添加附件?", "提示", {})
                  .then(() => {
                    this.doUpload(res.result.infos.orderId);
                  })
                  .catch(() => {}); //一定别忘了这个;
              }
              this.resetInfo(true);
              this.$message({
                message: "下单成功!",
                type: "success"
              });
            } else {
              this.$message.error({
                message: res.msg
              });
            }
          })
          .catch(() => {}); //一定别忘了这个;
      }
    },
    //查询
    doSelect: async function() {
      this.postApi.crud = "r";
      this.postApi.info = {
        key: this.key
      };
      this.listLoading = true;
      this.message = await this.$doPost("/api/production/order", this.postApi);
      if (this.message.msgCode == 0) {
        this.total = this.message.result.infos.length;
        this.getPageInfo();
      } else {
        this.$message.error(this.message.msg);
        this.getPageInfo();
      }
      this.listLoading = false;
    },
    //删除
    doDelete: function(orderId) {
      this.$confirm("是否删除单据: " + orderId, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.postApi.crud = "d";
          this.postApi.info = {
            key: orderId
          };
          let res = await this.$doPost("/api/production/order", this.postApi);
          if (res.msgCode === 0) {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.resetInfo(true);
          } else {
            this.$message.error("删除失败");
          }
        })
        .catch(() => {
          // this.$message.error("删除失败");
        });
    },
    //分页
    handleCurrentChange(val) {
      this.page = val;
      this.getPageInfo();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPageInfo();
    },
    getPageInfo() {
      this.pageInfos = [];
      for (
        let i = this.pageSize * (this.page - 1);
        i < this.pageSize * this.page;
        i++
      ) {
        if (i == this.message.result.infos.length) break;
        this.pageInfos.push(this.message.result.infos[i]);
      }
    },
    //查看附件
    doShowUpload: async function(orderId) {
      this.postApi.crud = "r";
      this.postApi.info = {
        key: orderId
      };
      this.message = await this.$doPost("/api/production/look", this.postApi);
      if (this.message.msgCode == 0) {
        this.uploadFrom = {
          visible: true,
          title: "订单号: " + orderId,
          ordreId: "",
          crud: "r",
          files: this.message.result.infos
        };
      } else {
        this.$message.error(this.message.msg);
      }
    },
    //显示上传附件弹窗
    doUpload: function(orderId) {
      this.uploadFrom = {
        visible: true,
        title: "订单号:" + orderId,
        orderId: orderId,
        crud: "c",
        files: {}
      };
    },
    //删除附件
    deUpload: function(orderId) {
      this.$confirm("是否删除单据: " + orderId + "的附件", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.postApi.crud = "d";
          this.postApi.info = {
            key: orderId
          };
          this.message = await this.$doPost(
            "/api/production/look",
            this.postApi
          );
          if (this.message.msgCode == 0) {
            this.resetInfo(true);
          } else {
            this.$message.error(this.message.msg);
          }
        })
        .catch(() => {
          // this.$message.error("删除失败");
        });
    },
    //上传附件
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleExceed(files, fileList) {
      this.$message.warning("只能上传两个文件");
    },
    uploadSuccess() {
      this.resetInfo(true);
    },
    getCustomers: async function() {
      let message = await this.$doGet("/api/basedata/customer");
      if (message.msgCode == 0) {
        this.customers = message.result.infos;
      }
    },
    test: function() {
      console.log("df");
      //这是网上的一张图片链接
      var url = "http://p1.pstatp.com/large/435d000085555bd8de10";
      getBase64(url);
      function getBase64(imgUrl) {
        window.URL = window.URL || window.webkitURL;
        var xhr = new XMLHttpRequest();
        xhr.open("get", imgUrl, true);
        // 至关重要
        xhr.responseType = "blob";
        xhr.onload = function() {
          if (this.status == 200) {
            //得到一个blob对象
            var blob = this.response;
            // console.log("blob", blob);
            //  至关重要
            let oFileReader = new FileReader();
            oFileReader.onloadend = function(e) {
              let base64 = e.target.result;
              console.log("方式一》》》》》》》》》", base64);
            };
            oFileReader.readAsDataURL(blob);
          }
        };
        xhr.send();
      }
    },
    addDate: function(date, days) {
      var d = new Date(date);
      d.setDate(d.getDate() + days);
      var m = d.getMonth() + 1;
      return d.getFullYear() + "-" + m + "-" + d.getDate();
    }
  },
  computed: {},
  watch: {
    "order.type": {
      handler(val, oldVal) {
        if (this.dialogFrom.disabled == false) {
          var now = new Date();
          if (this.order.createTime != "") {
            var now = new Date(this.order.createTime);
          }
          if (val == "C") {
            this.dialogFrom.suggestDate = this.addDate(now, 8) + " (5+1)";
          } else if (val == "P") {
            this.dialogFrom.suggestDate = this.addDate(now, 10) + " (7+1)";
          }
        } else {
          this.dialogFrom.suggestDate = "";
        }
      }
    },
    deep: true, // 加这个才能监听到属性
    immediate: true

    // label: {
    //   handler(val, oldVal) {
    //     if (val.leftBorderMin > val.leftBorderMax) {
    //       console.log(val.leftBorderMin)
    //       console.log(val.leftBorderMax)
    //       console.log(oldVal.leftBorderMin)
    //       if (val.leftBorderMin == oldVal.leftBorderMin) {
    //         this.label.leftBorderMax = oldVal.leftBorderMax;
    //       } else {
    //         this.label.leftBorderMin = oldVal.leftBorderMin;
    //       }
    //     }
    //     // if (val.rightBorderMin > val.rightBorderMin) {
    //     //   val.rightBorderMin = oldVal.rightBorderMin;
    //     // }
    //     // if (val.leftBorderMax < val.leftBorderMin) {
    //     //   val.leftBorderMax = oldVal.leftBorderMax;
    //     // }
    //     // if (val.rightBorderMax < val.rightBorderMin) {
    //     //   val.rightBorderMax = oldVal.rightBorderMax;
    //     // }
    //   },
    //   deep: true
    // }
  },
  props: {
    roles: Array
  }
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/production/Order.vue